module.exports = __webpack_public_path__ + "static/img/会议服务@2x (1).e9c27be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/会议服务@2x (1).png
// module id = NHdI
// module chunks = 1